import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface Props {
  columns: string[];
  rows: Record<string, any>[];
  onChange: (rows: Record<string, any>[]) => void;
}

export const StructuredPreviewTable = ({ columns, rows, onChange }: Props) => {
  const updateCell = (index: number, column: string, value: string) => {
    const next = rows.map((r, i) => (i === index ? { ...r, [column]: value } : r));
    onChange(next);
  };

  const removeRow = (index: number) => onChange(rows.filter((_, i) => i !== index));

  return (
    <div className="max-h-[28rem] overflow-auto rounded-lg border">
      <Table>
        <TableHeader className="sticky top-0 bg-card">
          <TableRow>
            {columns.map((c) => (
              <TableHead key={c} className="whitespace-nowrap">{c}</TableHead>
            ))}
            <TableHead className="w-12" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              {columns.map((c) => (
                <TableCell key={c} className="p-1">
                  <Input
                    value={row[c] === null || row[c] === undefined ? "" : String(row[c])}
                    onChange={(e) => updateCell(i, c, e.target.value)}
                    className="h-8 min-w-[8rem] border-transparent bg-transparent focus-visible:border-input"
                  />
                </TableCell>
              ))}
              <TableCell className="p-1">
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-muted-foreground hover:text-destructive"
                  onClick={() => removeRow(i)}
                  aria-label={`Delete row ${i + 1}`}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
